<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
		<vs-col vs-lg="8" vs-sm="12">
			<vs-button :to="`/settings/add`" color="primary" type="filled">
				Add Seller
			</vs-button>
		</vs-col>
    </vs-row>
    <vx-card>
		<b-table
			ref="table"
			style="min-height: 600px"
			striped
			hover
			fixed
			responsive
			show-empty
			sort-icon-left
			:selectable="true"
			:select-mode="`multi`"
			:busy.sync="isBusy"
			:items="dataProvider"
			:fields="columns"
			:current-page="currentPage"
			:per-page="perPage"
		>
			<template v-slot:table-busy>
				<div class="text-center text-danger my-2" style="height: 600px">
					<b-spinner class="align-middle"></b-spinner>
					<div class="mt-3">
					<strong>Loading...</strong>
					</div>
				</div>
			</template>

			<template v-slot:cell(name)="data">
				<strong>{{ data.item.name }}</strong>
			</template>

			<template v-slot:cell(action)="data">
				<vs-button @click="open(data.item)" color="primary" type="flat">
					Edit
				</vs-button>
			</template>
		</b-table>
		<div class="mt-3 text-right">
			<vs-pagination
				:total="Math.ceil(totalRows / 30)"
				:max="7"
				v-model="currentPage"
				prev-icon="arrow_back"
				next-icon="arrow_forward"
			></vs-pagination>

			<div class="mt-3">
			{{ from | numFormat("0,0") }} to {{ to | numFormat("0,0") }} of
			{{ totalRows | numFormat("0,0") }} orders
			</div>
		</div>
    </vx-card>
  </div>
</template>
<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Service from "../../../services";

export default {
	data: () => ({
		columns: [
			{ label: "ID", key: "merchant_id", sortable: false },

			{
				label: "Merchant Name",
				key: "name",
				sortable: false,
				tdClass: "width-600"
			},
			{ label: "", key: "action", sortable: false }
		],
		from: 1,
		to: 0,
		isBusy: false,
		currentPage: 1,
		perPage: 30,
		totalRows: 0,
		selected: [],
		filterOn: [],
		pageOptions: [2, 5, 10, 15, 30, 50]
	}),
	watch: {
		'currentPage'(val, oldVal) {
			if (oldVal != val) {
				this.getDataPage(val)
			}
		}
	},
	methods: {
		dataProvider(ctx, callback,) {
			setTimeout(() => {
				this.isBusy = true;
				let data = {
					e: this.$route.query.e,
					s: this.$route.query.s,
				};

				let params = Object.keys(data)
				.map(key => key + "=" + data[key])
				.join("&");

				params =
				params +
				"&" +
				Object.keys(ctx)
					.map(key => key + "=" + ctx[key])
					.join("&");

				Service.Merchant.getSeller(data.s, this.currentPage)
				.then(res => {
					this.isBusy = false;
					this.totalRows = res.data.total;
					this.from = res.data.from;
					this.to = res.data.to;
					this.data = res.data.data;
					this.perPage = res.data.per_page;
					// this.log = res.log;
					// this.lagacy_query = res.lagacy_query;
					if (res.data.data.length < this.perPage) {
						this.to = res.data.total;
					}

					callback(this.data);
				})
				.catch(() => {
					// console.log(error);
					// Here we could override the busy state, setting isBusy to false
					// this.isBusy = false
					// Returning an empty array, allows table to correctly handle
					// internal busy state in case of error
					//return [];
					callback([]);
				});
				return null;
			}, 1800);
		},
		open(item) {
			this.$router.push("/sellers/" + item.merchant_id + "/view");
		},
		getDataPage(page) {
			let data = {
				s: this.$route.query.s
			};
			Service.Merchant.getSeller(data.s, page)
				.then(res => {
					this.totalRows = res.data.total;
					this.from = res.data.from;
					this.to = res.data.to;
					this.data = res.data.data;
					this.perPage = res.data.per_page;
					if (res.data.data.length < this.perPage) {
						this.to = res.data.total;
					}
				})
				.catch(() => {
					// console.log(error);
				});
		}
	}
};
</script>